import React from 'react';
import styles from './ProjectsList.module.scss';

import { IntersectionObserverClient } from '../../../../../IntersectionObserver';
import { ReportListItemFallback } from '../../../../../Components/ReportList/ReportListItemFallback/ReportListItemFallback';
import { ProjectValue } from '../../../../../Models/ProjectValue';
import { ProjectCard } from './ProjectCard/ProjectCard';

export interface ProjectsListProps {
  projects: ProjectValue[];
}

export const ProjectsList = ({
  projects
}: ProjectsListProps): React.ReactElement<ProjectsListProps> => {
  return (
    <div className={styles.projectsList}>
      <div className={styles.content}>
        {projects &&
          projects.length > 0 &&
          projects.map((project: ProjectValue) => (
            <IntersectionObserverClient
              key={project.id}
              fallback={<ReportListItemFallback />}
            >
              <ProjectCard project={project} />
            </IntersectionObserverClient>
          ))}
      </div>
    </div>
  );
};
